import { HttpError } from 'utils/HttpError';
import { trackError } from 'utils/trackError';

import { SetErrorAction } from './error';

export function setError(error: Error, track = true): SetErrorAction {
  if (track && error instanceof HttpError && error.statusCode !== 404) {
    trackError(error);
  }

  return { type: 'SET_ERROR', error };
}
